import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { TenantDefault } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { createTenantDefaultApi, tenantDefaultKeys } from '../api';

export interface UseTenantDefaultsOptions {
  /** Set to false when the caller lacks `tenant-defaults:read` — skips the request entirely. */
  enabled?: boolean;
}

export function useTenantDefaults(options: UseTenantDefaultsOptions = {}): UseQueryResult<TenantDefault> {
  const { enabled = true } = options;
  const client = useApiClient('admin-auth');
  const api = createTenantDefaultApi(client);

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.fetchTenantDefaults(),
    queryKey: tenantDefaultKeys.detail(),
    staleTime: LIST_STALE_TIME_MS,
  });
}
